import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import TableComponent from "./../../components/TableComponent";
import { formatDate, formatListItems, isValidObject } from "./../../../utils";
import { headerColumn } from "./../../../constants";
import { getInstallerInventory } from "../../../actions/inventory";
import SearchableDropdown from "../../../Common/SearchDropdown";
import { getInstallers } from "../../../actions/installer";
import InventoryDetails from "../../Inventory/components/InventoryDetails";

const CompanyInventory = () => {
    const [state, setState] = useState({
        lists: [],
        loading: false,
        selected: null,
        search: "",
        company: "",
        type: "",
        current: 1,
        total: 1
    });
    
    const { filters, companies } = useSelector(({ inventory, companies }) => ({
        filters: inventory.filters,
        companies: companies
    }), shallowEqual);

    const { lists, loading, current, total, search, companyId, company, type, typeId, selected } = state;

    const getPurchases = (pageIndex) => {
        let query = `?page=${pageIndex ? pageIndex : current}&limit=200&type=companies`;
        if (search) query = `${query}&keyword=${search}`;
        if (company) query = `${query}&companyId=${companyId}`;
        if (type) query = `${query}&inventoryTypeId=${typeId}`;

        setState(prev => ({ ...prev, loading: true }));
        getInstallerInventory(query).then(response => {
            const { data, meta } = response.data;
            setState(prev => ({ ...prev, lists: data ?? [], total: meta?.total ?? 1 }));
        }).catch(ex => { }).finally(() => setState(prev => ({ ...prev, loading: false })))
    }

    const paginationAction = (pageIndex) => {
        setState(prev => ({ ...prev, current: pageIndex }));
        getPurchases(pageIndex)
    }

    const onSelectHandler = (key, value) => {
        setState(prev => ({ ...prev, [key]: value?.name ?? "", [`${key}Id`]: value?.id ?? null }));
    }

    const getInstallerList = () => {
        getInstallers().then(response => {
            const { data } = response.data;
            if (isValidObject(data)) {
                setState(prev => ({ ...prev, installerList: formatListItems(data?.installers ?? [], "installerId", "name") }));
            }
        }).catch(ex => { });
    }

    useEffect(() => {
        getInstallerList();
    }, [])

    useEffect(() => {
        paginationAction(1);
    }, [search, company, type, current])

    return <div className="inventory-container purchase">
        <TableComponent col={4} breakPoint="lg" title={"Company Inventory"} headers={headerColumn.companyInv} data={lists} current={current} total={total} tableLoading={loading} paginationAction={paginationAction} render={(tdData, index) => <tr onClick={() => setState(prev => ({ ...prev, selected: tdData }))} key={index}>
            <td>{(index ?? 0) + 1}</td>
            <td>{tdData?.installer_name ?? "-"}</td>
            <td>{tdData?.inventory_type ?? "-"}</td>
            <td>{tdData?.allocated ?? "-"}</td>
            <td>{tdData?.installed ?? "-"}</td>
            <td>{tdData?.remaining ?? "-"}</td>
            <td>{formatDate(tdData?.last_allocation_date ?? "")}</td>
        </tr>} FilterComponent={<div className="d-flex justify-content-end">
            <div className="me-2">
                <SearchableDropdown
                    placeholder={"Company Name"}
                    value={company}
                    error={false}
                    options={companies?.companies || []}
                    onSelect={(value) => onSelectHandler("company", value)}
                />
            </div>
            <div className="me-2">
                <SearchableDropdown
                    placeholder={"Inventory Type"}
                    value={type}
                    error={false}
                    options={filters?.inventoryTypes ?? []}
                    onSelect={(value) => onSelectHandler("type", value)}
                />
            </div>
        </div>} />
        {selected ? <InventoryDetails show={isValidObject(selected)} inventory={selected} hideModal={() => setState(prev => ({ ...prev, selected: null}))} showReasonModal={(data) => setState(prev => ({ ...prev, selected:null, discardData: data }))} type="companyId" /> : null}
    </div>
}

export default CompanyInventory;